export function uint8ArrayToFile(uint8Array: Uint8Array, fileName: string, mimeType: string): File {
    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: mimeType });
    
    // Create a File from the Blob
    const file = new File([blob], fileName, {
      type: mimeType,
      lastModified: Date.now()
    });

    return file;
}

export function fileToArrayBuffer(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        let data = reader.result as ArrayBuffer;
        resolve(data);
        data = null;
      };
  
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }

  export function blobToFile(blob: Blob, fileName: string, mimeType: string): File {
    // Create a File from the Blob
    const file = new File([blob], fileName, {
      type: mimeType,
      lastModified: Date.now()
    });

    return file;
}